<template>
  <div>
    <v-btn
      v-if="editReference == 0"
      :disabled="disabled"
      @click="editReference = 1"
      color="info"
    >
      <v-icon>person</v-icon>Search for entity
    </v-btn>
    <v-card v-if="editReference != 0">
      <v-card-text>
        <div v-if="editReference == 1">
          <h3>Search for entity</h3>
          <v-text-field
            label="Search by entity id"
            v-model="entityidSearchTemp"
            @input="searchEntity"
            outline
          />
          <Entity :id="entityidSearch" @loaded="updateLoaded($event)">
            <v-btn @click="updateEntity()" color="success">
              <v-icon>check_circle</v-icon>Use this
            </v-btn>
          </Entity>
          <v-alert :value="entityidSearch && !entityLoaded" type="warning"
            >No record found</v-alert
          >
          <v-alert :value="!entityidSearch && !entityLoaded" type="info"
            >No record selected</v-alert
          >
        </div>
        <hr />
        <v-btn @click="resetSearch" small>Cancel</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Entity from "@/components/directory/Entity.vue";
function initialState() {
  return {
    editReference: 0,
    timerId: null,
    entityidSearchTemp: "",
    entityidSearch: null,
    entityLoaded: false,
    valid: false,
    valueRules: [(v) => !!v || "Value is required"]
  };
}
export default {
  name: "EntitySearch",
  props: ["disabled"],
  components: { Entity },
  data: function () {
    return initialState();
  },
  methods: {
    updateLoaded(value) {
      this.entityLoaded = value;
    },
    searchEntity() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.entityidSearch = this.entityidSearchTemp;
      }, 750);
    },
    updateEntity() {
      this.$emit("updateEntity", this.entityidSearch);
      this.resetSearch();
    },
    resetSearch() {
      Object.assign(this.$data, initialState());
    }
  }
};
</script>